function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: "0"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M9.6 7.55a.75.75 0 00-1.2.9l1.73 2.3H9c-.41 0-.75.34-.75.75s.34.75.75.75h2.25v1H9c-.41 0-.75.34-.75.75s.34.75.75.75h2.25V16c0 .41.34.75.75.75s.75-.34.75-.75v-1.25H15c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-2.25v-1H15c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-1.12l1.73-2.3a.75.75 0 00-1.2-.9l-2.4 3.2-2.41-3.2zM12 20c4.42 0 8-3.58 8-8s-3.58-8-8-8-8 3.58-8 8 3.58 8 8 8z",
  opacity: ".3",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fillOpacity: ".87"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 22C6.48 22 2 17.52 2 12S6.48 2 12 2s10 4.48 10 10-4.48 10-10 10zm0-2c4.42 0 8-3.58 8-8s-3.58-8-8-8-8 3.58-8 8 3.58 8 8 8zM8.55 7.4a.75.75 0 011.05.15l2.4 3.2 2.4-3.2a.75.75 0 011.2.9l-1.73 2.3H15c.41 0 .75.34.75.75s-.34.75-.75.75h-2.25v1H15c.41 0 .75.34.75.75s-.34.75-.75.75h-2.25V16c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-1.25H9c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h2.25v-1H9c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h1.12L8.4 8.45a.75.75 0 01.15-1.05z",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fillOpacity: ".87"
}));